export const RemoveBrowserShortcuts = () => null;
